module.exports = __webpack_public_path__ + "static/media/island4r.9818553f.svg";